import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { loginDemo } from "../utils/demoAuth";

function DemoLogin() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleLogin = async () => {
    if (!username.trim() || !password) {
      setError("Enter demo username and password");
      return;
    }

    setLoading(true);
    setError("");

    try {
      await loginDemo(username, password);
      navigate("/demo/dashboard", { replace: true });
    } catch (error) {
      setError(error.message || "Invalid demo credentials");
      setLoading(false);
    }
  };

  return (
    <div className="login-page demo-login-page">
      <div className="login-card">
        <span className="soft-badge">Demo Mode - Sample Data</span>
        <h2>FinoraAI Live Demo</h2>
        <p>Login to explore the app with protected sample finance data.</p>

        <input
          type="email"
          placeholder="Demo username"
          value={username}
          onChange={(event) => setUsername(event.target.value)}
          onKeyDown={(event) => event.key === "Enter" && handleLogin()}
        />

        <input
          type="password"
          placeholder="Demo password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          onKeyDown={(event) => event.key === "Enter" && handleLogin()}
        />

        {error && <div className="login-error">{error}</div>}

        <button onClick={handleLogin} disabled={loading}>
          {loading ? "Starting demo..." : "Login to Demo"}
        </button>

      </div>
    </div>
  );
}

export default DemoLogin;
